import { AnimatePresence, motion } from "framer-motion"
import { Link } from "react-router"
import { cn } from "~/utils/style"

const brandPng = "/images/brand.png"
const logoPng = "/images/logo.png"

// TODO: Adicionar variantes com cslx
type LogoProps = {
  variant?: "brand" | "logo"
  size?: "sm" | "md"
}

export const Logo = ({ variant = "logo", size = "md" }: LogoProps) => (
  <Link to="/" className="flex">
    <img
      src={brandPng}
      className={cn(
        "flex size-8 shrink-0 select-none",
        variant === "logo" && "hidden",
      )}
    />

    <img
      src={logoPng}
      className={cn(
        "flex h-6 shrink-0 select-none",
        variant === "brand" && "hidden",
        size === "sm" && "h-6",
        size === "md" && "h-8",
      )}
    />
  </Link>
)

const BouncingDot = ({ delay }: { delay: number }) => (
  <motion.div
    className="size-3 rounded-full bg-[#2BB14C]"
    initial={{ y: 0 }}
    animate={{ y: [0, -12, 0] }}
    transition={{
      duration: 1.2,
      ease: "linear",
      repeat: Infinity,
      delay,
    }}
  />
)

type AnimatedSmallLogoProps = {
  shouldShow: boolean
}

export const AnimatedSmallLogo = ({ shouldShow }: AnimatedSmallLogoProps) => {
  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "linear" }}
        >
          <div
            className={cn(
              "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-baseline justify-center",
            )}
          >
            <div className="flex gap-2.5">
              {[0, 1, 2, 3].map(index => (
                <BouncingDot key={index} delay={index * 0.36} />
              ))}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
